var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

export default (function (value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) return false;

  var proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isPlainObject.js
// module id = 166
// module chunks = 0